import React, { PropTypes } from 'react';
import { Button, Modal, Card, message } from 'antd';
import AddTeacherModal from '../share/AddTeacherModal';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleActions from '../../actions/UserRoleActions';
import UserRoleStore from '../../stores/UserRoleStore';
import DataService from '../../lib/DataService';

import CurrentRoleActions from '../../actions/CurrentRoleActions';

export default class SetAdminPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      teachers: [],
      showModal: false,
      role: CurrentRoleStore.getCurrentRole(),
      resource_type: null,
      resource_id: null,
      admin_teachers: [],
      modal_title: null,
      schoolId: props.params.schoolId
    };
    // bind this
    this.callBack = this.callBack.bind(this);
    this.hideAddTeacherModel = this.hideAddTeacherModel.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);

    if (!this.state.role) {
      let schoolId = this.props.params.schoolId;
      let criteria = {schoolId : schoolId};
      CurrentRoleActions.findAndSetCurrentUserRole(criteria);
      this.setState({
        role: CurrentRoleStore.getCurrentRole()
      })
    }

    this.getAllTeachers();
  }

  getAllTeachers() {
    let admins = [];
    admins[0] = {name: '全校', resource_type: 'School', resource_id: this.state.schoolId, admins: []}
    DataService.getAllClassGrade(this.state.schoolId).then((res) => {
      res.map((grade, index) => {
        if (!grade.is_graduated) {
          admins.push({ name: grade.grade_name, resource_type: 'ClassGrade', resource_id: grade.id, admins: [] });
        }
      })

      DataService.getAllTeachers({school_id: this.state.schoolId, only_admin: true}).then((res) => {
        res.map((teacher) => {
          teacher.roles.map((role) => {
            admins.map((admin) => {
              if (admin.resource_type == role.resource_type && role.resource_id == admin.resource_id) {
                admin.admins.push(teacher);
              }
            })
          })
        })
        this.setState({
          teachers: admins
        })
      })
    })
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }


  setAdmin(admin){
    let data = this.state.teachers.find((data) => (data.resource_type == admin.resource_type && data.resource_id == admin.resource_id));
    this.setState({
      showModal: true,
      resource_type: admin.resource_type == 'School' ? 'school' : 'class_grade',
      resource_id: admin.resource_id,
      admin_teachers: data.admins,
      modal_title: admin.name
    })
  }

  callBack(teacher) {
    this.setState({
      showModal: false
    })
    if (teacher) {
      let data = {
        resource_type: this.state.resource_type,
        resource_id: this.state.resource_id,
        teacher_id: teacher.id
      }
      DataService.setAdmin(data).then((res) => {
        message.success('添加成功！');
        if (teacher.id == this.state.role.roleId) {
          let roles = UserRoleStore.getState();
          let add_role = {};
          if (data.resource_type == 'class_grade') {
            add_role = {
              id: this.state.role.id,
              roleId: this.state.role.roleId,
              roleName: 'teacher',
              fullName: this.state.role.fullName,
              associatName: "classGrade",
              associatObj: {
                id: this.state.resource_id,
                gradename: this.state.modal_title,
                schoolId: this.state.schoolId,
                schoolName: this.state.role.associatObj.schoolName,
                isGradeAdmin: true,
                isSchoolAdmin: true,
              }
            }
          } else if (data.resource_type == 'school'){
            add_role = {
              id: this.state.role.id,
              roleId: this.state.role.roleId,
              roleName: 'teacher',
              fullName: this.state.role.fullName,
              associatName: "school",
              associatObj: {
                id: this.state.resource_id,
                schoolId: this.state.schoolId,
                schoolName: this.state.role.associatObj.schoolName,
                isSchoolAdmin: true,
              }
            }
          }
          UserRoleActions.addUserRole(add_role)
        }
        this.componentDidMount();
      })
    }
  }

  hideAddTeacherModel() {
    this.setState({
      showModal: false
    })
  }

  deleteAdmin(teacher_id, resource_type, resource_id) {
    resource_type = resource_type == 'School' ? 'school' : 'class_grade';
    let data = {
      teacher_id: teacher_id,
      resource_type: resource_type,
      resource_id: resource_id
    }
    DataService.deleteAdmin(data).then((res) => {
      message.success('删除成功！');
      if (teacher_id == this.state.role.roleId) {
        let role = UserRoleStore.getState().find((role) => role.associatName == 'classGrade' && role.associatObj.id == resource_id);
        UserRoleActions.deleteUserRole(role.key)
      }
      this.componentDidMount();
    })
  }

  render() {
    return (
      <div className="set-admin-page">
        {this.state.teachers.map((admin, index) => <div className="admin-list-container" key={index}>
          <div className="admin-title">
            <span className="label">{admin.name + '管理员'}</span>
            <Button icon="plus-circle" className="default-button" onClick={this.setAdmin.bind(this, admin)}>添加{admin.name}</Button>
          </div>
          <div className="admin-list">
            {admin.admins.map((teacher) => <div className="admin-card" key={teacher.id}>
              {teacher.avatar_url && <img src={teacher.avatar_url ? teacher.avatar_url : "assets/user_avatar_icon.png"} className="avatar-image"/>}
              {!teacher.avatar_url && <div className="avatar-image default-avatar"></div>}
              <div className="admin-info">
                <div className="admin-detail">{teacher.full_name}</div>
                <div className="admin-detail">{teacher.mobile_phone}</div>
              </div>
              {!(admin.resource_type == 'School' && teacher.id == this.state.role.roleId) ? <a className="delete-btn" onClick={this.deleteAdmin.bind(this, teacher.id, admin.resource_type, admin.resource_id)}>删除</a> : ''}
            </div>)}
          </div>
        </div>)}


        <AddTeacherModal showModal={this.state.showModal} schoolId={this.state.schoolId} callBack={this.callBack} teachers={this.state.admin_teachers} title={"添加" + this.state.modal_title} onHideTeacherModel={this.hideAddTeacherModel}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/SetAdminPage.jsx